import { useNavigate } from 'react-router-dom';

import { STR } from '../i18n';
import { landingPath } from '../lib/surfaces';
import { BrandPanel } from '../ui/BrandPanel';

/**
 * THE REFUSAL, not a shell.
 *
 * A person without the capability for a surface must never reach a rendered page that then
 * fills with empty tables because every read 403'd. They get this instead: no navigation, no
 * controls, no reads issued at all — the guard in App.tsx never mounts the screen, so no
 * admin query is ever created for a non-admin. The server refuses the same requests
 * independently; this is the affordance half of that decision, never the enforcement.
 */
export function RefusalPage() {
  const navigate = useNavigate();
  return (
    <BrandPanel>
      <div>
        <div className="done-head">
          <span className="done-dot dot-warn" aria-hidden="true" />
          <h1 className="f-title">{STR.refusal.title}</h1>
        </div>
        <p className="lead">{STR.refusal.body}</p>
        <div className="actions">
          <button
            type="button"
            className="ghost btn"
            onClick={() => {
              navigate(landingPath(), { replace: true });
            }}
          >
            {STR.refusal.back}
          </button>
        </div>
      </div>
    </BrandPanel>
  );
}

/** An address with no surface declaration. Default-deny: it renders nothing of the app. */
export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <BrandPanel>
      <div>
        <div className="done-head">
          <span className="done-dot dot-neutral" aria-hidden="true" />
          <h1 className="f-title">{STR.notFound.title}</h1>
        </div>
        <p className="lead">{STR.notFound.body}</p>
        <div className="actions">
          <button
            type="button"
            className="ghost btn"
            onClick={() => {
              navigate(landingPath(), { replace: true });
            }}
          >
            {STR.notFound.back}
          </button>
        </div>
      </div>
    </BrandPanel>
  );
}
